"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceAwareOwnable__factory = void 0;
var ethers_1 = require("ethers");
var PriceAwareOwnable__factory = /** @class */ (function (_super) {
    __extends(PriceAwareOwnable__factory, _super);
    function PriceAwareOwnable__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PriceAwareOwnable__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PriceAwareOwnable__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PriceAwareOwnable__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PriceAwareOwnable__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PriceAwareOwnable__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return PriceAwareOwnable__factory;
}(ethers_1.ContractFactory));
exports.PriceAwareOwnable__factory = PriceAwareOwnable__factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newSigner",
                type: "address",
            },
        ],
        name: "TrustedSignerChanged",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_trustedSigner",
                type: "address",
            },
        ],
        name: "authorizeSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getMaxBlockTimestampDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getMaxDataTimestampDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receviedSigner",
                type: "address",
            },
        ],
        name: "isSignerAuthorized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_receivedTimestamp",
                type: "uint256",
            },
        ],
        name: "isTimestampValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=PriceAwareOwnable__factory.js.map